export const redirects = [
  {
    path: '/account-settings',
    name: 'account-settings',
    redirect: () => ({ name: 'account-settings-tab', params: { tab: 'account' } }),
  },
]
